import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import LoginActions from '../redux/loginRedux'
import LoginDialog from '../components/LoginDialog'
import { withErrorBoundary } from '../errors/ErrorBoundary'

const styles = theme => ({
  image: {
    height: '200px'
  },
  button: {},
  header: {
    backgroundColor: theme.palette.primary['50']
  },
  container: {
    overflowY: 'scroll',
    '&::-webkit-scrollbar': { width: '0px' }
  }
})

class SplashScreen extends PureComponent {
  render() {
    const { authenticated, classes, actions, error } = this.props

    if (authenticated) {
      return null
    }

    return (
      <Dialog open={!authenticated} classes={{ paper: classes.container }}>
        <LoginDialog onSignIn={actions.loginRequested} onLoginFailed={actions.loginFailed} error={error} />
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticated: state.login.authenticated,
    error: state.login.error
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      authenticate: () => dispatch(LoginActions.authenticate()),
      loginRequested: () => dispatch(LoginActions.loginRequested()),
      loginFailed: (error) => dispatch(LoginActions.loginFailed(error))
    }
  }
}

export default withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(SplashScreen))
)



// WEBPACK FOOTER //
// ./src/containers/SplashScreen.js